export type CandidateMessageDirection = 'RECRUITER' | 'CANDIDATE';

export interface CandidateMessage {
  id: string;
  direction: CandidateMessageDirection;
  body: string;
  senderName: string;
  createdAt: string;
  emailQueued: boolean;
}

export const isCandidateMessage = (
  value: unknown
): value is CandidateMessage => {
  if (!value || typeof value !== 'object') return false;

  const candidateMessage = value as Partial<CandidateMessage>;
  return (
    typeof candidateMessage.id === 'string' &&
    (candidateMessage.direction === 'RECRUITER' ||
      candidateMessage.direction === 'CANDIDATE') &&
    typeof candidateMessage.body === 'string' &&
    typeof candidateMessage.senderName === 'string' &&
    typeof candidateMessage.createdAt === 'string' &&
    typeof candidateMessage.emailQueued === 'boolean'
  );
};

export interface CandidateMessageThread {
  applicationId: string;
  candidateName: string;
  jobTitle: string;
  companyName: string;
  emailAllowed: boolean;
  messages: CandidateMessage[];
}

export interface PublicCandidateMessageThread {
  candidateName: string;
  jobTitle: string;
  companyName: string;
  expiresAt: string;
  messages: CandidateMessage[];
}
